const caseSummary = {
  title: "Case Details",
  description:
    "Case name and case team members can be managed from this page. The Case Name should be a reference for the entire case. Once created the Case Short Name will be used for report names, creditor and claim reference numbers, and should not be changed. Ideally the Case Short Name should be less than 8 characters.",
  fieldLabelDetails: {
    caseName: "Case Name",
    caseDescription: "Case Description",
    caseShortName: "Case Short Name",
    status: "Status",
    statusOpen: "Open",
    statusClose: "Close",
    caseNameFrench: "Case Name (French)",
    caseDescriptionFrench: "Case Description (French)",
    caseTeam: "Case Team",
    teamMember: "Team Member",
    role: "Role",
    caseIdentifiers: "Case Identifiers",
    caseTeamSetup: "Case Team Setup",
    inviteUserPlaceholder: "Search For Team Member within",
    appDirectory: "App Directory",
    eyDirectory: "EY Directory",
    directoryPlaceholder: "Directory",
    rolePlaceHolder: "Select Role",
    currentTeamMembers: "Current Team Members",
    userDeleteMessage: "Do you want to remove the user: {{userName}}",
    caseViewer: "Case Viewer",
    caseContributor: "Case Contributor",
    caseManager: "Case Manager",
    userDoesNotExistMessage:
      "The selected user is not an application user yet, please contact admins.",
    userExistMessage: "User already exists in the case",
    userInvitedMessage: "User Invited Successfully",
    updatedRoleMessage: "User Role Updated Successfully",
    fillAllFieldsMessage:
      "Please complete all required fields to continue. {{notFilledFields}} cannot be left blank",
    caseTeamSetupErrorMessages: "Select {{notFilledFields}}",
    notificationRecipients: "Notification Recipients",
  },
};

export default caseSummary;
